import './App.css';
import {useLocalStorage} from "./utils/useLocalStorage";
import Login from "./screens/0-login";
import Elements from "./screens/1-elements";
import React, {useEffect, useRef, useState} from "react";
import Synch from "./screens/2-synch";
import TechControl from "./screens/3-tech_control";
import ModalStatus from "./components/modal_status";
import api from "./api";
import {toast, ToastContainer} from "react-toastify";
import {handleErrorConfirm, handlerError} from "./utils/handlerError";
import Brigade from "./screens/4-brigade";
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import Timekeeper from "./screens/timekeeper";

function App() {
    const [newData, setNewData] = useState({})
    const [page, setPage] = useState(1)
    const [data, setData] = useState()
    const [statusColored, setStatusColored] = useState(false)
    const [subDataStatus, setSubDataStatus] = useState(null)
    const [headerData, setHeaderData] = useState({})
    const [token, setToken] = useLocalStorage('token', null)
    const [selectedValues, setSelectedValues] = useState({
        coach_type_number: null,
        coach_type_id: null,
        coachMax: null
    })
    // status can be a stop, update, choice, wait, update_techcontrol
    const [status, setStatus] = useState(null)
    const [statusMainTech, setStatusMainTech] = useState(null)
    const stompClientRef = useRef(null);
    const socketRef = useRef(null);
    const reconnectTimeoutRef = useRef(null);
    const isInitialConnect = useRef(true);
    const [authData, setAuthData] = useState({});

    useEffect(() => {
        localStorage.removeItem("coach_type_id");
        localStorage.removeItem("coach_type_number");
    }, []);

    const successElements = async () => {
        try {
            setStatus('wait');
            const res = await api().post(`/coach/element/confirm/${token}`, data && data?.map((el) => ({
                "score_element_id": el.score_element_id,
                "value": el.value
            })))
            if (res?.data?.status === 'error') {
                handleErrorConfirm(res?.data?.error || 'Ошибка')
                setStatus("update");
            }

        } catch (e) {
            setStatus("update");
            console.log(e)
        }
    }

    const successArtistik = async () => {
        try {
            setStatus('wait');
            const res = await api().post(`/coach/impression/confirm/${token}`, data && data?.map((el) => ({
                "score_artistic_id": el.score_artistic_id,
                "artistic_type_id": el.artistic_type_id,
                "value": el.value
            })))
            if (res?.data?.status === 'error') {
                handleErrorConfirm(res?.data?.error || 'Ошибка')
                setStatus("update")
            }

        } catch (e) {
            setStatus("update");
            console.log(e)
        }
    }

    function setActualData() {
        let score1 = newData?.score_synchro?.find((f) => f.synchro_type_id === 1)?.value;
        let score2 = newData?.score_synchro?.find((f) => f.synchro_type_id === 2)?.value;
        let score3 = newData?.score_synchro?.find((f) => f.synchro_type_id === 3)?.value;

        data.forEach((item) => {
            if (item.synchro_type_id === 1) {
                item.value = score1;
            }
            if (item.synchro_type_id === 2) {
                item.value = score2;
            }
            if (item.synchro_type_id === 3) {
                item.value = score3;
            }
        })
    }

    const successSynchro = async () => {
        setStatus('wait');
        setActualData();
        try {

            const res = await api().post(`/coach/synchro/confirm/${token}`,
                data?.map(el => {
                    const v = Number(el.value) || 0;           // NaN → 0, undefined → 0, null → 0

                    return {
                        score_synchro_id: el.score_synchro_id,
                        synchro_type_id: el.synchro_type_id,
                        value:
                            el.synchro_type_id === 1 ? (v === 0 ? 0 : Math.round(v * 10)) :
                                el.synchro_type_id === 2 ? (v === 0 ? 0 : v / 0.5) :
                                    el.synchro_type_id === 3 ? (v === 0 ? 0 : v / 3) :
                                        0
                    };
                }) ?? []
            );

            if (res?.data?.status === 'error') {
                handleErrorConfirm(res?.data?.error || 'Ошибка')
                setStatus('update');
            }

        } catch (e) {
            setStatus("update");
            console.log(e)
        }
    }

    const successTechcontrol = async () => {
        try {
            setStatus('wait');
            const res = await api().post(`/coach/techcontrol/confirm/${token}`, data && data?.map((el) => ({
                "score_tech_control_id": el.score_tech_control_id,
                "value": el.type || '0'
            })))
            if (res?.data?.status === 'error') {
                handleErrorConfirm(res?.data?.error || 'Ошибка')
                setStatus("update");
            }

        } catch (e) {
            setStatus("update");
            console.log(e)
        }
    }

    const successBrigade = async () => {
        try {
            const res = await api().get(`/coach/brigade/confirm/${token}`)
            if (res?.data?.status === 'error') {
                handleErrorConfirm(res?.data?.error || 'Ошибка')
                return
            }
            setStatus('wait')
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        const updateData = async () => {

            const header = await api().post(`coach/status/${token}`);

            setHeaderData(header.data)

            const pathToData =
                (selectedValues.coach_type_id === 1 && 'elements') ||
                (selectedValues.coach_type_id === 2 && 'artistic_type') ||
                (selectedValues.coach_type_id === 3 && 'synchro_type') ||
                (selectedValues.coach_type_id === 4 && 'elements');

            const pathToRequest =
                (selectedValues.coach_type_id === 1 && `coach/element/elements_short/${token}`) ||
                (selectedValues.coach_type_id === 2 && `coach/impression/artistic_type/${token}`) ||
                (selectedValues.coach_type_id === 3 && `coach/synchro/synchro_type/${token}`) ||
                (selectedValues.coach_type_id === 4 && `coach/techcontrol/elements/${token}`);

            try {
                if (selectedValues.coach_type_id === 6) {
                    return;
                }
                const data = await api().post(pathToRequest)

                if (data?.data?.status === 'error') {
                    handlerError(data, setData)
                    return;
                }

                setData(data.data[pathToData]?.map((el) => ({...el, value: 0})))

            } catch (e) {
                console.log(e)
            } finally {
                setStatus(null)
            }
        }
        if (status === 'update') {
            updateData()
        }
    }, [status])

    useEffect(() => {

        const getSubDataStatus = async () => {
            try {
                const res = await api().post(`coach/techcontrol/other/${token}`)
                if (res?.data?.status === 'error') {
                    handleErrorConfirm(res?.data?.error || 'Ошибка')
                    return
                }
                const sortData = {
                    ...res.data,
                    techcontrol_other:
                        res.data.techcontrol_other.sort((a, b) => a.techcontrol_number - b.techcontrol_number).map((el, i) => ({
                            ...el,
                            elements: el.elements.sort((a, b) => a.number - b.number)
                        }))
                }
                console.log(sortData, 'sortData')
                setSubDataStatus(sortData)
            } catch (e) {
                console.log(e)
            }
        }
        if (statusColored) {
            getSubDataStatus()
            setStatus(null)
        } else {
            setSubDataStatus(null)
        }
    }, [statusColored])

    useEffect(() => {

        const getSubDataStatus = async () => {
            try {
                const res = await api().post(`coach/techcontrol/other/${token}`)
                if (res?.data?.status === 'error') {
                    handleErrorConfirm(res?.data?.error || 'Ошибка')
                    return
                }
                const sortData = {
                    ...res.data,
                    techcontrol_other:
                        res.data.techcontrol_other.sort((a, b) => a.techcontrol_number - b.techcontrol_number).map((el, i) => ({
                            ...el,
                            elements: el.elements.sort((a, b) => a.number - b.number)
                        }))
                }
                setSubDataStatus(sortData)
            } catch (e) {
                console.log(e)
            }
        }
        console.log(statusMainTech, 'h1')
        if (statusMainTech === 'update_techcontrol' && page === 5 && statusColored) {
            getSubDataStatus()
        } else {
            setSubDataStatus(null)
        }
    }, [statusMainTech, status])

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }, [page])

    useEffect(() => {
        window.addEventListener("beforeunload", alertUser);
        return () => {
            window.removeEventListener("beforeunload", alertUser);
        };
    }, []);

    const alertUser = (e) => {
        e.preventDefault();
        e.returnValue = "";
    };

    useEffect(() => {

        const connect = async () => {
            socketRef.current = new SockJS(`${process.env.REACT_APP_SOCKET_URL}`);
            stompClientRef.current = Stomp.over(socketRef.current);
            stompClientRef.current.debug = null;
            stompClientRef.current.heartbeat.outgoing = 2000;
            stompClientRef.current.heartbeat.incoming = 2000;

            socketRef.current.onopen = () => {
                if (isInitialConnect.current) {
                    isInitialConnect.current = false;
                } else {
                    toast.success('Соединение с сервером активно!');
                }

                mainChooseHandler();

                if (reconnectTimeoutRef.current) {
                    clearTimeout(reconnectTimeoutRef.current);
                    reconnectTimeoutRef.current = null;
                }
            };

            socketRef.current.onclose = () => {
                toast.error('Соединение с сервером разорвано!');
                attemptReconnect();
            };

            socketRef.current.onerror = (error) => {
                console.error('WebSocket ошибка:', error);
            };

            stompClientRef.current.connect({}, function (frame) {
                    toast.dismiss();
                    activeToasts.delete('Соединение с сервером разорвано!');

                    if (isInitialConnect.current) {
                        isInitialConnect.current = false;
                    } else {
                        toast.success('Соединение с сервером активно!', {autoClose: false});
                    }

                    if (reconnectTimeoutRef.current) {
                        clearTimeout(reconnectTimeoutRef.current);
                        reconnectTimeoutRef.current = null;
                    }

                    stompClientRef.current.subscribe('/topic/msg', async function (greeting) {
                        const res = JSON.parse(greeting.body);
                        const token = localStorage.getItem('token');
                        if (res?.method === 'choice_token' && res?.token === token) {
                            const res = await api().post('coach/coach_type');
                            setAuthData(res.data);
                            setPage(1);
                            stompClientRef.current.disconnect(() => {
                                console.log('Соединение закрыто');
                            });
                        }

                        if (res?.method === 'select') {
                            await selectCoach(res.coach_type_id, res.coach_number);
                            const resAuth = await api().post('coach/coach_type');
                            setAuthData(resAuth.data);
                        }

                        if (res.status === 'update_techcontrol') {
                            setStatusMainTech(res.status);
                            return;
                        }
                        setStatus(res.status);

                        if (res.status === 'choice') {
                            const res = await api().post('coach/coach_type');
                            setAuthData(res.data);
                            setPage(1);
                            stompClientRef.current.disconnect(() => {
                                console.log('Соединение закрыто');
                            });
                        }
                    });

                    stompClientRef.current.subscribe('/user/topic/private-messages', async function (greeting) {
                        const res = JSON.parse(greeting.body);

                        console.log(res)

                        const pathToData =
                            (res.coach_type_id === 1 && 'elements') ||
                            (res.coach_type_id === 2 && 'artistic_type') ||
                            (res.coach_type_id === 3 && 'synchro_type') ||
                            (res.coach_type_id === 4 && 'elements') ||
                            (res.coach_type_id === 6 && 'elements');

                        const pathToPage =
                            (res.coach_type_id === 1 && 2) ||
                            (res.coach_type_id === 2 && 3) ||
                            (res.coach_type_id === 3 && 4) ||
                            (res.coach_type_id === 4 && 5) ||
                            (res.coach_type_id === 5 && 6) ||
                            (res.coach_type_id === 6 && 7);

                        const pathToRequest =
                            (res.coach_type_id === 1 && `coach/element/elements_short/${res.token}`) ||
                            (res.coach_type_id === 2 && `coach/impression/artistic_type/${res.token}`) ||
                            (res.coach_type_id === 3 && `coach/synchro/synchro_type/${res.token}`) ||
                            (res.coach_type_id === 4 && `coach/techcontrol/elements/${res.token}`) ||
                            (res.coach_type_id === 5 && `coach/brigade/users/${res.token}`) ||
                            (res.coach_type_id === 6 && `coach/element/elements_short/${res.token}`);

                        if (res.status === 'ok') {
                            setToken(res.token);

                            try {
                                console.log(pathToRequest)
                                const data = res.coach_type_id === 5 ? await api().get(pathToRequest) : await api().post(pathToRequest);
                                const header = await api().post(`coach/status/${res.token}`);

                                let scores = [];
                                if (res.coach_type_id === 1) {
                                    for (let datumKey in data?.data[pathToData]) {
                                        scores.push({
                                            score_element_id: data?.data[pathToData][datumKey].score_element_id,
                                            value: null
                                        });
                                    }

                                    const valueProcess = await api().post("coach/element/process_value", scores);

                                    setData(data?.data[pathToData]?.map((el) => ({
                                        ...el,
                                        value: getElementScoreValue(el.score_element_id, valueProcess),
                                    })))
                                } else if (res.coach_type_id === 2) {
                                    for (let datumKey in data?.data[pathToData]) {
                                        scores.push({
                                            score_artistic_id: data?.data[pathToData][datumKey].score_artistic_id,
                                            value: null
                                        });
                                    }

                                    const valueProcess = await api().post("coach/impression/process_value", scores);

                                    setData(data?.data[pathToData]?.map((el) => ({
                                        ...el,
                                        value: getImpressionScoreValue(el.score_artistic_id, valueProcess),
                                    })))
                                } else if (res.coach_type_id === 4) {
                                    for (let datumKey in data?.data[pathToData]) {
                                        scores.push({
                                            score_tech_control_id: data?.data[pathToData][datumKey].score_tech_control_id,
                                            value: null
                                        });
                                    }

                                    const valueProcess = await api().post("coach/tech_control/process_value", scores);
                                    setData(data?.data[pathToData]?.map((el) => ({
                                        ...el,
                                        value: getTechControlScoreValue(el.score_tech_control_id, valueProcess)
                                    })))
                                } else {
                                    setData(res.coach_type_id === 5 ? data?.data : data?.data[pathToData]?.map((el) => ({
                                        ...el,
                                        value: null,
                                    })))
                                }

                                setHeaderData(header.data);
                                setStatusColored(data?.data?.is_main_techcontrol ? data?.data?.is_main_techcontrol : false);
                                setPage(pathToPage);

                            } catch (e) {
                                console.log(e)
                                toast.error('Ошибка!', {
                                    position: "bottom-left",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    theme: "colored",
                                });
                            }
                        } else {
                            toast.error(res.error, {
                                position: "bottom-left",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "colored",
                            });
                        }
                    });

                    mainChooseHandler();

                }, (
                    error
                ) => {
                    console.error('Ошибка подключения STOMP:', error);
                    attemptReconnect();
                    if (activeToasts.has('Соединение с сервером разорвано!')) {
                        return;
                    }
                    toast.dismiss();
                    toast.error('Соединение с сервером разорвано!', {autoClose: false});
                    activeToasts.add('Соединение с сервером разорвано!');
                }
            );
        };

        const attemptReconnect = () => {

            // Проверяем, активна ли вкладка
            if (document.visibilityState === 'hidden') {
                console.log('Вкладка неактивна, переподключение отложено');
                return;
            }

            reconnectTimeoutRef.current = setTimeout(async () => {
                await connect();
            }, 2000);
        };

        // Обработчик изменения видимости вкладки
        const handleVisibilityChange = async () => {
            if (document.visibilityState === 'visible') {
                // Вкладка стала активной, пробуем подключиться, если соединение разорвано
                if (!socketRef.current || socketRef.current.readyState !== WebSocket.OPEN) {
                    console.log('Вкладка активна, пробуем восстановить соединение');
                    await connect();
                }
            } else {
                // Вкладка неактивна, очищаем таймер переподключения
                if (reconnectTimeoutRef.current) {
                    clearTimeout(reconnectTimeoutRef.current);
                    reconnectTimeoutRef.current = null;
                }
            }
        };

        // Добавляем слушатель события изменения видимости
        document.addEventListener('visibilitychange', handleVisibilityChange);

        connect().then(r => {
        });

        return () => {
            if (stompClientRef.current) {
                stompClientRef.current.disconnect();
            }
            if (socketRef.current) {
                socketRef.current.close();
            }
            if (reconnectTimeoutRef.current) {
                clearTimeout(reconnectTimeoutRef.current);
            }
        };

    }, []);

    const activeToasts = new Set();


    function getElementScoreValue(score_element_id, valueProcess) {
        return valueProcess?.data?.find(a => a.score_element_id === score_element_id).value;
    }

    function getImpressionScoreValue(score_artistic_id, valueProcess) {
        return valueProcess?.data?.find(a => a.score_artistic_id === score_artistic_id).value;
    }

    function getTechControlScoreValue(score_tech_control_id, valueProcess) {
        return valueProcess?.data?.find(a => a.score_tech_control_id === score_tech_control_id).value;
    }

    const selectCoach = async (coach_type_id, coach_number) => {
        setSelectedValues({
            coach_type_number: coach_number,
            coach_type_id: coach_type_id
        })
        mainChooseHandler();
    }

    const mainChooseHandler = async (method) => {

        let coach_type_id;
        let coach_type_number;

        if (selectedValues.coach_type_id === null) {
            coach_type_id = localStorage.getItem("coach_type_id");
        } else {
            localStorage.setItem("coach_type_id", selectedValues.coach_type_id);
            coach_type_id = selectedValues.coach_type_id;
        }

        if (selectedValues.coach_type_number === null) {
            coach_type_number = localStorage.getItem("coach_type_number");
        } else {
            localStorage.setItem("coach_type_number", selectedValues.coach_type_number);
            coach_type_number = selectedValues.coach_type_number;
        }

        console.log("coach_type_id: " + coach_type_id + ", coach_type_number: " + coach_type_number)

        if (coach_type_id === null || coach_type_number === null) {
            if (method === 'click') {
                toast.error('Выберите все поля!', {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
        } else {
            stompClientRef.current.send("/socket/auth", {}, JSON.stringify({
                'method': 'auth',
                'coach_type_id': coach_type_id,
                'coach_type_number': coach_type_number
            }));

        }
    }

    return (
        <div className="App">

            {page === 1 &&
                <Login selectedValues={selectedValues} setSelectedValues={setSelectedValues}
                       mainChooseHandler={mainChooseHandler} setAuthData={setAuthData} authData={authData}
                />}

            {page === 2 &&
                <Elements status={status} confirm={successElements} headerData={headerData} data={data}
                          selectedValues={selectedValues}
                          setData={setData}
                          setPage={setPage} isArtistik={false}/>}
            {page === 3 && status !== 'update' &&
                <Elements status={status} confirm={successArtistik} headerData={headerData} data={data}
                          selectedValues={selectedValues}
                          setData={setData}
                          setPage={setPage} isArtistik={true}/>}

            {page === 4 &&
                <Synch token={token} status={status} confirm={successSynchro} data={data} newData={newData}
                       setData={setData}
                       headerData={headerData}
                       setPage={setPage}
                       setNewData={setNewData}
                />}
            {page === 5 &&
                <TechControl subDataStatus={subDataStatus} statusColored={statusColored}
                             confirm={successTechcontrol}
                             status={status} data={data} headerData={headerData}
                             setData={setData} setPage={setPage}/>}
            {page === 6 &&
                <Brigade successBrigade={successBrigade} subDataStatus={subDataStatus} statusColored={statusColored}
                         confirm={successTechcontrol}
                         data={data} headerData={headerData}
                         setData={setData} setPage={setPage}/>}

            {page === 7 &&
                <Timekeeper headerData={headerData}
                            stompClient={stompClientRef.current}
                            coachTypeId={selectedValues.coach_type_id}
                            coachTypeNumber={selectedValues.coach_type_number}
                />
            }

            {status === 'stop' &&
                <ModalStatus open={true} status={status}/>
            }
            {(status === 'wait' && page === 6) &&
                <ModalStatus isBrigade={page === 6} open={true} status={'wait'}/>
            }



            <ToastContainer
                position="bottom-left"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </div>
    );
}

export default App;
